import { LngLatEntity } from '@/shared/entities/LngLatEntity'
import type { ShipmentLiveRouteEntity } from './ShipmentLiveRouteEntity'

export class JobLiveRouteEntity {
  inRearrangement?: boolean
  monitoringShipmentRoutes?: Array<ShipmentLiveRouteEntity> | null
  trackedDriverRoute?: {
    route?: string | null
  }
  currentDriverLocation?: LngLatEntity
}
